import type { TOC } from '@ember/component/template-only'
import { or } from 'ember-truth-helpers'
import sticky from 'teacher-ui-client/modifiers/sticky'

interface Signature {
  Element: HTMLTableCellElement
  Args: {
    z?: number
  }
  Blocks: {
    default: []
  }
}

export const StickyHeaderColumnTable: TOC<Signature> = <template>
  <th class="bg-inherit" ...attributes {{sticky header=true column=true z=(or @z "6")}}>
    {{yield}}
  </th>
</template>

export default StickyHeaderColumnTable
